module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABB0lEQVQokX3Ru0pDQRSF4S8H0olWggas1U4QmxQiKSxUDMR3CFiYQrHWB9DWJoLptfZSGMFGwUuwEy1VEN8hxsIdOEmOblgMs9f6Z/YwuWq1qq9msIv52F9jB0/pUNIHlXCDMr5CZdyGlwnm0UAOy5gKLaETXj4LLGICdZym+mc4DK+YBY7F+mKwnvsyPeBrrAsZYKkv0wO2cIcK9lEI7WEtvFYW2EEN39jER2grerXIDIAVnKd6n6Fu7iJu7gErOMEImpjDeGgWlxjGcRdOMIojv/9XxyLuU5M8Ru8gMg0UEmzEaVdYR9tgdd/YxBBqCVbD3P4D6lY7MrCSYBrvePgHSo/9hskf3/c5bMPteYwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/预约.png
// module id = En+N
// module chunks = 1